export default __webpack_public_path__ + "024a4ee8ce89e34970f2593b5df823dd.png";